(function TripSummaryAgentSchedule($, Adzuki)
{
	'use strict';

	let daysDrake       = null;
	let componentsDrake = null;
	const component     = {
		template: '#ts-agent-schedule',
		emits   : [
			'addSection',
			'setItineraryStyle',
			'add',
			'addDay',
			'componentMoved',
			'dayMoved',
			'labelChanged',
			'removeDay',
			'updateRootDate',
		],
		inject: [
			'formatDate',
			'formatTime',
			'getFaIconStyle',
			'isEmptyObject',
		],
		props: {
			sectionMode: {
				type   : Boolean,
				default: false,
			},
			changeDates: {
				type   : Boolean,
				default: true,
			},
			componentTypes: {
				type   : Array,
				default: [],
			},
			fitBuilderTypeId: {
				type   : Number,
				default: 1,
			},
			itinerary: {
				type   : Object,
				default: {},
			},
			loadingTripSummary: {
				type   : Boolean,
				default: false,
			},
			oneWayCounts: {
				type   : Map,
				default: new Map(),
			},
			// TS-417: keyed by day number, relayed to each day header
			removalStates: {
				type   : Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				// quick-start labels for proposals organized by options
				sectionPresets: [
					'Hotel Options',
					'Activity Options',
					'Flight Options',
					'Cruise Options',
					'Transportation',
					'Good to Know',
				],
			};
		},
		computed: {
			// section mode: proposals organize by option-group "sections" unless
			// the trip opted into day-by-day (root passes the resolved mode down)
			containerNoun() {
				return this.sectionMode ? 'Section' : 'Day';
			},
			// a brand-new proposal: exactly one container with nothing in it —
			// the moment to suggest organizing by options instead of days
			firstContainerEmpty() {
				const dayNumbers = Object.keys(this.itinerary);

				if (dayNumbers.length !== 1) {
					return false;
				}

				const only = this.itinerary[dayNumbers[0]];

				return !only.label && !only.date && (!only.components || only.components.length === 0);
			},
		},
		methods: {
			addComponent(component) {
				this.$emit('add', component);
			},
			addDay(type, onDayNumber) {
				const eventData = {
					type,
					onDayNumber,
				};

				this.$emit('addDay', eventData);
			},
			getItineraryDayLabel(dayNumber) {
				// called from the template with a hard-coded day 1, which is not
				// guaranteed to exist just because the itinerary is non-empty
				const day = this.itinerary[dayNumber];

				return (day && day.label) || `${this.containerNoun} ${dayNumber}`;
			},
			addPresetSection(label) {
				this.$emit('addSection', label);
			},
			setStyle(style) {
				this.$emit('setItineraryStyle', style);
			},
			// relayed up from ts-schedule-day's inline label editor
			labelChanged() {
				this.$emit('labelChanged');
			},
			labelFirstContainer(label) {
				const firstDayNumber = Object.keys(this.itinerary)[0];

				if (firstDayNumber) {
					this.itinerary[firstDayNumber].label = label;

					// the preset chips write the label straight into the itinerary, so
					// they had the same problem the pencil did -- persist it now rather
					// than leaving it to an explicit header Save
					this.$emit('labelChanged');
				}
			},
			getItineraryLastDayNumber() {
				let lastDayNumber = 1;

				for (const dayNumber in this.itinerary) {
					if (dayNumber > lastDayNumber) {
						lastDayNumber = dayNumber;
					}
				}

				return parseInt(lastDayNumber);
			},
			// TS-416. A drag passes over the other days' grips and titles and opens
			// their tooltips; the drop then redraws the days, the elements those
			// tooltips belong to are replaced, the mouseleave that would close them
			// never fires, and they stay on screen. Hide what is open, then remove
			// any already orphaned -- the attachment drag does the same.
			//
			// TS-416 QA: only the tooltips that EXIST are hidden. Under Bootstrap 5,
			// $(...).tooltip('hide') creates an instance on every element it is
			// called on (getOrCreateInstance), so each drag left all ~140
			// [data-toggle="tooltip"] elements with hover listeners of their own
			// beside the page-wide delegated ones on body.
			clearTooltips() {
				document.querySelectorAll('[data-toggle="tooltip"]').forEach((el) => {
					const tooltip = (window.bootstrap ? window.bootstrap.Tooltip.getInstance(el) : null);

					if (tooltip) {
						tooltip.hide();
					}
				});

				$('.tooltip').remove();
			},
			getItineraryFirstDayNumber() {
				const dayNumbers = Object.keys(this.itinerary).map((dayNumber) => parseInt(dayNumber));

				return dayNumbers.length ? Math.min(...dayNumbers) : 1;
			},
			// TS-415: Move Up / Move Down on a day header. Emits exactly what the
			// drag drop does, where targetDayNumber is the day it lands BEFORE --
			// so down by one is n + 2, and past the last day is last + 1.
			moveDayBy(dayNumber, direction) {
				const targetDayNumber = (direction === 'up') ? dayNumber - 1 : dayNumber + 2;

				// the arrow being hovered is redrawn by the move, like a drop (TS-416)
				this.clearTooltips();

				this.$emit('dayMoved', {
					currentDayNumber: dayNumber,
					targetDayNumber,
				});
			},
			async updateDragulaContainers() {
				await this.$nextTick();

				// add the schedule days container to the dragula instance
				const scheduleDaysContainer = this.$refs.scheduleDaysContainer;

				if (daysDrake) {
					daysDrake.containers = [];
					daysDrake.containers.push(scheduleDaysContainer);
				}

				if (componentsDrake) {
					const dayComponents = this.$refs.scheduleDay;

					componentsDrake.containers = [];

					if (dayComponents && dayComponents.length > 0) {
						for (const dayComponent of dayComponents) {
							const dayContainer = dayComponent.$refs.dayComponentsContainer;
							componentsDrake.containers.push(dayContainer);
						}
					}
				}

				// auto scroll the itinerary when dragging a day or component
				const scheduleScrollContainer = this.$refs.scheduleScrollContainer;

				autoScroll([
					window,
					scheduleScrollContainer
				], {
					margin    : 50,
					pixels    : 20,
					maxSpeed  : 20,
					autoScroll: function autoScrolling() {
						return this.down && (daysDrake.dragging || componentsDrake.dragging);
					}
				});
			},
			updateRootDate(date, dayNumber) {
				this.$emit('updateRootDate', date, dayNumber);
			},
		},
		watch: {
			itinerary: {
				handler() {
					this.updateDragulaContainers();
				},
				once: false,
				deep: true,
			},
		},
		mounted() {
			// initialize dragula instance that handles reordering of days
			daysDrake = dragula({
				moves: (el, source, handle) => {
					return handle.classList.contains('ts-day-drag');
				},
				revertOnSpill  : true,
				mirrorContainer: document.getElementById('ts-itinerary'),
			});

			// initialize dragula instance that handles reordering of components
			componentsDrake = dragula({
				moves: (el, source, handle) => {
					// TS-408: the whole <li> is the handle, but only for a row the day
					// marks ts-drag (componentCanBeDragged). Without this, cruise and
					// round-trip rows showed no grip and still dragged.
					return el.classList.contains('ts-drag');
				},
				// ADZ-8483: a leg of a round trip or a multi-leg one-way on an
				// Itinerary is placed by its own date, so it may be reordered within
				// its day but not dropped on another one
				accepts: (el, target, source) => {
					return !el.classList.contains('ts-drag-same-day') || target === source;
				},
				revertOnSpill  : true,
				mirrorContainer: document.getElementById('ts-itinerary'),
			});

			// TS-416: on pick-up and after every drop, cancel or spill (dragend
			// follows all three), for days and component rows alike
			for (const drake of [daysDrake, componentsDrake]) {
				drake.on('drag', () => this.clearTooltips());
				drake.on('dragend', () => this.clearTooltips());
			}

			// handle when a day is dropped
			daysDrake.on('drop', (el, target, source, sibling) => {
				const currentDayNumber = parseInt(el.dataset.dayNumber);
				let targetDayNumber    = 1;

				if (sibling) {
					targetDayNumber = parseInt(sibling.dataset.dayNumber);
				} else {
					targetDayNumber = this.getItineraryLastDayNumber() + 1;
				}

				this.$emit('dayMoved', {
					currentDayNumber,
					targetDayNumber,
				});

				daysDrake.cancel();
			});

			// handle when a component is dropped
			componentsDrake.on('drop', (el, target, source, sibling) => {
				const fromDayNumber = source.dataset.dayNumber;
				const toDayNumber   = target.dataset.dayNumber;
				const componentId   = parseInt(el.dataset.componentId);
				const sourceOrder   = [];
				const targetOrder   = [];
				const eventData     = {
					componentId,
					fromDayNumber,
					toDayNumber,
				};

				let index = 0;
				for (const child of source.children) {
					const componentId = parseInt(child.dataset.componentId);

					if (componentId) {
						sourceOrder.push({
							id       : componentId,
							sortOrder: index,
						});
						index++;
					}
				}

				index = 0;
				for (const child of target.children) {
					const componentId = parseInt(child.dataset.componentId);

					if (componentId) {
						targetOrder.push({
							id       : componentId,
							sortOrder: index,
						});
						index++;
					}
				}

				// remove last dropped element from DOM, Vue will update the UI
				if (source.children.length === 0) {
					componentsDrake.remove();
				}

				componentsDrake.cancel();

				eventData.sourceOrder = sourceOrder;
				eventData.targetOrder = targetOrder;

				this.$emit('componentMoved', eventData);
			});
		},
		beforeUnmount() {
			if (daysDrake) {
				daysDrake.destroy();
				daysDrake = null;
			}

			if (componentsDrake) {
				componentsDrake.destroy();
				componentsDrake = null;
			}
		},
	};

	Adzuki.VueComponents.TripSummaryAgentSchedule = component;
}(jQuery, window.Adzuki || {}));
